export const CHANGE_MESSAGE = "CHANGE_MESSAGE";



// WEBPACK FOOTER //
// ./src/redux/HelloWorld/constants.js